import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFullscreen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Icon / fullscreen",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			fillOpacity: .8
		}), /* @__PURE__ */ _jsx("path", {
			id: "icon",
			d: "M6.55556 6.55556H10.4444V5H5V10.4444H6.55556V6.55556ZM10.4444 17.4444H6.55556V13.5556H5V19H10.4444V17.4444ZM19 13.5556H17.4444V17.4444H13.5556V19H19V13.5556ZM17.4444 10.4444H19V5H13.5556V6.55556H17.4444V10.4444Z",
			fill: "black"
		})]
	})
});
export default SvgFullscreen;
